import React from 'react';
import { cn } from '@discover-lib/utils';

export type SkeletonProps<C extends React.ElementType = 'div'> = PolymorphicComponentProps<C>;

export default function Skeleton<C extends React.ElementType = 'div'>({
  as,
  children,
  className,
  ...props
}: SkeletonProps<C>) {
  const Component = as || 'div';

  return (
    <Component
      className={cn('animate-pulse select-none rounded bg-skeleton text-transparent', className)}
      disabled
      aria-disabled
      {...props}>
      {children}
    </Component>
  );
}
